import App_vue_vue_type_script_setup_true_lang_default from "./App.vue.script.js";
//#region src/App.vue
var App_default = App_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { App_default as default };

//# sourceMappingURL=App.vue.js.map